<template>
  <div class="empty-state">
    <div class="empty-state__icon-wrap">
      <v-icon v-if="icon" size="40" color="primary">{{ icon }}</v-icon>
    </div>
    <h3 class="empty-state__title">{{ title }}</h3>
    <p v-if="description" class="empty-state__description">{{ description }}</p>
    <div v-if="$slots.default || actionLabel" class="empty-state__actions">
      <slot>
        <v-btn
          v-if="actionLabel"
          color="primary"
          :to="actionTo"
          @click="$emit('action')"
        >{{ actionLabel }}</v-btn>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: { type: String, default: "" },
    title: { type: String, required: true },
    description: { type: String, default: "" },
    actionLabel: { type: String, default: "" },
    actionTo: { type: [String, Object], default: null },
  },
};
</script>

<style scoped lang="scss">
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;

  &__icon-wrap {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-color: rgba(226, 120, 47, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: #0f172a;
    margin: 0 0 6px;
  }

  &__description {
    font-size: 14px;
    line-height: 1.5;
    color: rgba(15, 23, 42, 0.6);
    max-width: 420px;
    margin: 0;
  }

  &__actions {
    margin-top: 20px;
  }
}
</style>
